export const ApiHeader = {
  UserType : '0',
  'Content-Type': 'application/json'
}

export const DEFAULTDATE = "1900-01-01T00:00:00";

export const LOGINPAGE ="Login"
export const REGISTERPAGE = "Register"
export const DASHBOARDPAGE="Dashboard"
// Data Section
export const POPULARDESTINATIONPAGE="PopularDestinations"
export const ADDBOOKINGPACKAGE = "AddBookingPackage"
export const ADDVEHICLELIST = "AddVehicleList"
export const BOOKINGPACKAGELIST = "BookingPackageList"

// Setting Section
export const ADDUSERFORM = "AddUserForm"
export const USERADMINLIST = "UserAdminList"
export const PROFILE = "Profile"
export const CHANGEPASSWORD = "ChangePassword"
export const USERAUTH = "UserAuth"

// Customer Section 
export const ADDCUSTOMER = "AddCustomer"
export const CUSTOMERLIST = "CustomerList"

// Extra Section
export const FAQS = "Faqs"
export const SMTP = "SMTPDetails"
export const COUPONS = "Coupons"
export const CONTACTUS = "ContactUs"

//Driver Section
export const ADDAGENCY = "AddAgency"
export const AGENCYLIST = "AgencyList"
export const VEHICLELIST = "VehicleList"
export const APPROVEDAGENCY = "ApprovedAgency"
export const APPROVEDVEHICLE = "ApprovedVehicle"
export const APPROVEDDRIVER = "ApprovedDriver"
export const DRIVERLIST = "DriverList"

//BOOKING SECTION
export const BOOKINGLIST = "BookingList"
export const CANCELBOOKINGLIST = "CancelBookingList"
export const ASSIGNDRIVER = "AssignDriver"
export const REASSIGNDRIVER = "Re-AssignDriver"

export const UPDATEAGENCYALLDETAILS = "UpdateAgencyAllDetails"

export const BOOKINGLEADS = "BookingLead"
// global data key

//REGEX CONSTANTS
export const PHONENOREGEX = /^\d{10}$/;
export const EMAILREGEX = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i

//API ERROR NULL
export const APINULLERROR = "API returned an invalid response"
export const APICALLFAIL = "API call failed:"

//FETCH DATA ERROR
export const FETCHDATAERROR = "Error while fetching data"
//SAVE DATA ERROR
export const SAVEDATAERROR = "Error while saving data"
//DELETE DATA ERROR
export const DELETEDATAERROR = "Error while deleting data"
//UPDATE DATA ERROR
export const UPDATEDATAERROR = "Error while updating data"

//ACTION COLUMN HEADING
export const ACTION = "Action"
//SERIAL NO DATA KEY
export const SRNOKEY = "srNo"

//SERIAL NO COLUMN NAME
export const SRNO = "Sr No"
//SERIAL NO WIDTH
export const SRNOWIDTH = 50
export const WIDTH = 50

export const ApiHeaders = {
  UserType: "1",
  "Content-Type": "application/json",
};

export const ApiHeadersUserType = {
  UserType: "0",
  "Content-Type": "application/json",
};

export const ApiHeadersMultipart = {
  UserType: "1",
  "Content-Type": "application/json",
};

// edit data for driver section
export const EDIT = "Edit"
export const APPROVE = "Approve"

// for coloumn 
export const INT = "Int"
export const TEXT = "Text"
export const DATE = "Date"

//Booking types
export const ONEWAY = "oneway"
export const ROUNDWAY = "round"

